import { useFetch } from './useFetch';
import type { AsyncState } from './useFetch';
import { fetchRequest, fetchRequests } from '@/api/requests';
import type { RequestsQuery } from '@/api/requests';
import type { RequestListResponse, RequestRecord } from '@/api/types';

export function useRequests(query: RequestsQuery = {}): AsyncState<RequestListResponse> {
  const key = JSON.stringify(query);
  return useFetch<RequestListResponse>((signal) => fetchRequests(query, signal), [key]);
}

export function useRequest(id: number | undefined): AsyncState<RequestRecord> {
  return useFetch<RequestRecord>(
    (signal) => {
      if (id == null || !Number.isFinite(id)) return Promise.reject(new Error('id is required'));
      return fetchRequest(id, signal);
    },
    [id ?? 0],
  );
}
